import React,{useState, useRef, useContext, useEffect, memo} from 'react'
import { Outlet, NavLink, Link, useLoaderData, useLocation } from "react-router-dom";
import { ThemeContext } from '../context/ThemeContext';
import { useDarkMode } from '../customhooks/ThemeHook';
import ProgressiveImage from './ProgressiveImage/FirstSlider';
import ProgressiveImageImg from './ProgressiveImage/FirstSlider';

import gsap from 'gsap'
/*import './work_4.css'*/



const WorkNews = memo( (props) => {

  //const featuredImage = 'https://discover.af-pictures.com/storage/app/uploads/public/c23/4f8/aee/thumb__1300_700_0_0_crop.jpg';
    const featuredImage = '/static/trans.gif';
  const theme = useContext(ThemeContext);
  const [darkMode, setDarkMode] = useDarkMode(false);
  const selectedWork = useRef();
  let NewsData = useLoaderData();
  //console.log(NewsData)
  let News = NewsData.data;
  var source_url = '';


  const location = useLocation();
  const [projectsGrid,setProjectsGrid] = useState(0);

    useEffect(() => {


      if( location.pathname.split('/').length === 2 ){
        setProjectsGrid(1);
      }else{
        setProjectsGrid(0);
      }



      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, [location]);






  function transitionEffect(e){
    gsap.to(selectedWork.current,1,{ delay:1, opacity:0,ease:'easeIn' });
  }

  useEffect((props) => {


    var debugInput = document.querySelector("input");
   function updateDebugState() {
       document.body.classList.toggle('debug-on', debugInput.checked);
   }
   debugInput.addEventListener("click", updateDebugState);
   updateDebugState();
});







  return (
    <div className="w-full text-center items-center">


      { projectsGrid == 1 ?
        <>
          <div style={{backgroundImage: 'url(' + featuredImage + ')',backgroundPosition:'center', backgroundSize:'cover'}} className="relative background-cover h-[40vh]">
            <h1 style={{fontSize:'300%'}} className="text-center w-full pt-[20vh] text-8xl text-white">NOTICIAS AF FILMS</h1>
        </div>

        {/* <div className="w-full colorChange text-gray-900 fadeIn">
          <h2 style={{fontSize:'2em'}} className="text-8xl  text-center px-8 py-12 pb-4 text-inherit">Noticias</h2>
          </div>
*/}
          <div className=" w-full py-8 bg-whitep pt-18 pl-3 md:pl-10">


            <div style={{borderBottom: '1px solid #000'}} className="w-[95.5%] h-1 mb-4"/>

            <div className="p-6 md:pl-32">

            {News.length > 0 ? News.map((news,index) => (

            index < 6 ?

            <div className="w-full text-white px-2 mb-2 flex text-md " key={'doc-'+ index}>
              <div className="text-left">
                {news.url ?
              <a className="overflow-hidden mb-10" target="_blank" href={news.url} state={{ from: 'home', backLink:'noticias' }}>
              <div className="flex flex-col items-center pb-6 space-y-1 text-left">
                <p className="inter-title  notranslate  pb-2 text-wrap text-xl md:text-2xl">
                  <span className="inline-block branding "><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="px-auto size-6 inline mr-4 -mt-2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
                </svg> </span>{news.title}

                    <br/>

                    <span className="newsLine inline-block mr-4"></span><small className="mt-4 font-light">{new Date(news.date).toLocaleDateString()}</small>
                </p>
              </div>

            </a> :

            <NavLink className="overflow-hidden mb-18" to={'../noticias/'+news.slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'noticias' }}>
            <div className="flex flex-col items-center pb-6 space-y-1 text-left">
                <p className="notranslate   pb-2 text-wrap text-xl md:text-2xl">{news.title}<br/>
                    <span className="newsLine inline-block mr-4"></span><small className="mt-4 font-light">{new Date(news.date).toLocaleDateString()}</small>
              </p>
            </div>

          </NavLink>

          }
              </div>
            </div>

             : ''     ))  : ''}

          </div>
          </div>
        </>
         :
         '' }



    <div style={{display:'none'}} className="debug">
    <label><input type="checkbox"/>Debug </label>
  </div>

  <div className="z-900">
  <Outlet/>
</div>

</div>
  )
})

export default WorkNews
